<template>
  <div class="app">
    <AppHeader fixed>
      <b-link class="navbar-brand" to="/dashboard"
        ><span>AUXILIUM</span></b-link
      >
      <b-navbar-nav class="ml-auto">
        <b-nav-item class="d-md-down-none">
          <user-info-header></user-info-header>
        </b-nav-item>
        <b-nav-item class="d-md-down-none notif-wrap">
          <font-awesome-icon :icon="['fas', 'bell']" />
          <span class="notif-pill"></span>
        </b-nav-item>
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <main class="main-admin">
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import AppHeader from '../components/layoutComponent/Header'
import UserInfoHeader from '../components/user/UserInfoHeader'
export default {
  name: 'DefaultContainer',
  components: {
    AppHeader,
    UserInfoHeader
  }
}
</script>



// WEBPACK FOOTER //
// src/container/LargeContainer.vue